/**
 * History Page
 * Page component that uses the History Container
 * Follows Container-Presenter pattern
 */

import React from 'react';
import SeoHead, {
  DEFAULT_META_DESCRIPTION,
  DEFAULT_META_TITLE,
} from '../../components/common/SeoHead';
import { HistoryContainer } from '@/components/history';

export default function HistoryPage() {
  return (
    <>
      <SeoHead
        title={DEFAULT_META_TITLE}
        description={DEFAULT_META_DESCRIPTION}
        path='/history'
        disableTitleSuffix
      />
      <HistoryContainer />
    </>
  );
}
